export class GetHofAction {
  static readonly type = "[Hall of Fame] Get scores";
}

export class GetSiteHoFAction {
  static readonly type = "[Hall of Fame] Get site scores";
}